import {fnToastrFormError, resetForm} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnDataFieldTable = function () {
    var tableName = '#datatable-data-fields';
    var modal = $('#modal-add-data-field');

    if (!element_exists(tableName) || $.fn.dataTable.isDataTable(tableName)) return false;

    $('#tab_data_fields').click(function () {
        $(tableName).DataTable().ajax.reload(null, false);
    });

    $('#datatable-data-fields tbody').off('click', 'tr');
    $('#datatable-data-fields tbody').on('click', 'tr', function () {
        var tableData = table.row(this).data();
        var checked = tableData.data_field_status;

        $('#data_field_id').val(tableData.data_field_id);
        console.log(tableData);
        $('#data_field_name').val(tableData.data_field_name);
        if (checked == 1) {
            $('#data_field_status').prop('checked', true);
        } else {
            $('#data_field_status').prop('checked', false);
        }
        $('#data-field-select').val(tableData.data_field_group).change();
        $('#data_field_color').val(tableData.data_field_color).change();
        $('#delete-data-field').removeClass('hidden');
        $('#update-data-field').removeClass('hidden');
        $('#submit-data-field').addClass('hidden');
        modal.modal('show');
    });

    $('#add-data-field').on('click', function () {
        modal.modal('show');
        $('#delete-data-field').addClass('hidden');
        $('#update-data-field').addClass('hidden');
        $('#submit-data-field').removeClass('hidden');
    });

    $('#add-data-field-form').off('submit').on('submit', function (e) {
        e.preventDefault();
        var data_field_name = $('#data_field_name').val();
        var data_field_select = $('#data-field-select').val();
        var data_field_color = $('#data_field_color').val();
        var data_field_status;

        if ($('#data_field_status').is(":checked")) {
            data_field_status = 'on';
        } else {
            data_field_status = '';
        }

        $.ajax({
            type: 'POST',
            url: '/addDataField',
            data: {
                data_field_name: data_field_name,
                data_field_status: data_field_status,
                data_field_select: data_field_select,
                data_field_color: data_field_color,
            },
            success: function (response) {
                modal.modal('hide');
            },
            error: fnToastrFormError,
        })
    });

    $('#delete-data-field').click(function (e) {
        e.preventDefault();
        var data_field_id = $('#data_field_id').val();
        $.ajax({
            type: 'POST',
            url: '/deleteDataField',
            data: {
                data_field_id: data_field_id,
            },
            success: function (response) {
                $(tableName).DataTable().ajax.reload(null, false);
                modal.modal('hide');
            },
            error: fnToastrFormError,
        })
    });

    $('#update-data-field').click(function (e) {
        e.preventDefault();
        var data_field_id = $('#data_field_id').val();
        var data_field_name = $('#data_field_name').val();
        var data_field_select = $('#data-field-select').val();
        var data_field_color = $('#data_field_color').val();
        var data_field_status;

        if ($('#data_field_status').is(":checked")) {
            data_field_status = 'on';
        } else {
            data_field_status = '';
        }

        $.ajax({
            type: 'POST',
            url: '/updateDataField',
            data: {
                data_field_id: data_field_id,
                data_field_name: data_field_name,
                data_field_status: data_field_status,
                data_field_select: data_field_select,
                data_field_color: data_field_color,
            },
            success: function (response) {
                $(tableName).DataTable().ajax.reload(null, false);
                modal.modal('hide');
            },
            error: fnToastrFormError,
        })
    });

    modal.off().on('hidden.bs.modal', function () {
        resetForm($('#add-data-field-form'));
        $(tableName).DataTable().ajax.reload(null, false);
    });

    var columns = [
        {data: 'data_field_id'},
        {data: 'data_field_name'},
        {data: 'data_field_status_text'},
        {data: 'data_field_group'},
        {data: 'data_field_color_lang'},
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {className: "p-l-10", width: "20%", targets: 0},
        {className: "p-l-10", width: "20%", targets: 1},
        {className: "p-l-10", width: "20%", targets: 2},
        {className: "p-l-10", width: "20%", targets: 3},
        {className: "p-l-10", width: "20%", targets: 4}
    ];

    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');
    var table = $(tableName).DataTable({
        language: allLangFiles.datatables,
        ajax: {
            type: 'POST',
            url: '/getDataFields',
        },
        columns: columns,
        columnDefs: columnDefs,
        bFilter: false,
        destroy: true,
        bInfo: false,
        pageLength: 5,
        bLengthChange: false,
        scrollX: true,
        lengthMenu: [10, 25, 50, 75, 100],
        initComplete: function (settings, json) {
            table.draw();
        },
    });
};